/**
 * Links from the app (app.agapae.gr) back to the marketing site (agapae.gr).
 *
 * The base URL comes from VITE_LANDING_PAGE_URL, tolerating both a bare host
 * ("agapae.gr") and a full origin, with any trailing slash trimmed so callers
 * can always append a path. This logic was previously copy-pasted verbatim in
 * every call site; it lives here now so the legal links can't drift apart.
 */

const DEFAULT_LANDING_URL = 'https://agapae.gr';

export function getLandingBaseUrl(): string {
  let baseUrl = (import.meta.env.VITE_LANDING_PAGE_URL || DEFAULT_LANDING_URL).replace(/\/$/, '');
  if (baseUrl && !baseUrl.startsWith('http')) {
    baseUrl = `https://${baseUrl}`;
  }
  return baseUrl;
}

/** Marketing-site Terms of Service page. */
export function getTermsUrl(): string {
  return `${getLandingBaseUrl()}/terms`;
}

/** Marketing-site Privacy Policy page. */
export function getPrivacyPolicyUrl(): string {
  return `${getLandingBaseUrl()}/privacy-policy`;
}
